import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { ContractStatus, enquiriesPath, Enquiry, Plan, subscriptionsPath, Term } from '@parkupp/core'
import { addDoc, collection, doc, serverTimestamp, updateDoc } from '@angular/fire/firestore'
import * as firestore from 'firebase/firestore'
import { ClientService } from '../../../services/client.service'
import { ActivatedRoute, Router } from '@angular/router'
import { LazyLoaderService } from '../../../services/lazy-loader.service'

@Component({
    selector: 'app-corporate-page',
    templateUrl: './corporate-page.component.html',
    styleUrls: ['./corporate-page.component.scss'],
})
export class CorporatePageComponent implements OnInit {
    formGroup: FormGroup
    calculatorForm: FormGroup
    formLoading = false
    formError = ''
    enquiry: Enquiry
    formComplete = false
    merchantFaqs: any[] = []
    calculatedRevenue = 'R0'

    constructor(private fb: FormBuilder, private clientService: ClientService, private router: Router, private activatedRoute: ActivatedRoute, private lazyLoaderService: LazyLoaderService) {
        if (this.activatedRoute.snapshot.paramMap.get('status')) {
            this.formComplete = true
        }

        this.enquiry = new Enquiry()

        this.formGroup = this.fb.group({
            name: [''],
            email: [''],
            phone: [''],
            location: [''],
            bays: [''],
            detail: [''],
        })

        this.calculatorForm = this.fb.group({
            numBays: [0],
            costPerBay: [0],
            numMonths: [0],
        })

        // Auto-calculate when form values change
        this.calculatorForm.valueChanges.subscribe(() => {
            this.calculateRevenue()
        })
    }

    ngOnInit(): void {
        // this.lazyLoaderService.loadElfsightJsScript()

        // Initialize calculator
        this.calculateRevenue()

        this.merchantFaqs.push({
            question: `How can I list my parking on ParkUpp`,
            answer: `We have built the site to be quite intuitive, please click on “list a parking” on our website and follow the process. Please contact us should you require assistance.`,
        })
        this.merchantFaqs.push({
            question: `How long can I list my parking for?`,
            answer: `ParkUpp Monthly - You can list your parking for a minimum period of one month. Parkers using
            ParkUpp monthly prefer a 6 - 12 month contract.
            <br><br>
            ParkUpp Events - You can list available parking for the day of a specific event.
            <br><br>
            ParkUpp Flex - This allows you to list your parking in a vacant building one month at a time allowing you to end all contracts before your new tenant moves in. Parkers will submit a new parking reservation request one month at a time.
            <br><br>
            ParkUpp Collector  - You can list your parking for a minimum period of one month. Parkers using
            ParkUpp Collector prefer a 6 - 12 month contract.`,
        })
        this.merchantFaqs.push({
            question: `How should I price my listing on ParkUpp?`,
            answer: `We recommend that your parking fee be in line with competing parking in your area. Obviously the cheaper the more likely you are to attract parkers. Please contact us if we can assist.`,
        })
        this.merchantFaqs.push({
            question: `When will I get paid?`,
            answer: `ParkUpp collects parking fees through our Paygate infrastructure and pays to parking owners the received fee less ParkUpps service percentage on the 7th of the following month. Please contact us should require an alternate arrangement.`,
        })
        this.merchantFaqs.push({
            question: `What is ParkUpp’s 15% management, payment, and marketing fee for?`,
            answer: `<p>The 15% fee covers the comprehensive services ParkUpp provides to make parking space rental effortless for you. This includes:</p>
            
            <h4>Management Services:</h4>
            <ul>
                <li>Handling bookings, reservations, and customer inquiries.</li>
                <li>Providing customer support to parkers.</li>
                <li>Ensuring smooth operations so you don't have to deal with day-to-day administration.</li>
            </ul>
            
            <h4>Payment Processing:</h4>
            <ul>
                <li>Ensure collection of payments from parkers (Through dedication payment gateway).</li>
                <li>Handling refunds or payment disputes.</li>
                <li>Providing you with a seamless revenue stream without manual invoicing or chasing payments.</li>
            </ul>
            
            <h4>Marketing & Promotion:</h4>
            <ul>
                <li>Digital marketing efforts to attract renters to your parking space.</li>
                <li>Optimising listings for better visibility on search engines and our platform.</li>
            </ul>
            
            <p><strong>Example:</strong> if you choose to rent your parking bay out for R800 a month, ParkUpp will charge R120 every month for the duration of the contract. R 680 will be transferred to the property owner by the 7th of the following month, each month, until the contract expires.</p>
            `,
        })
        this.merchantFaqs.push({
            question: `How can I get further assistance?`,
            answer: `Please reach out to the below:
            <br><br>
            Kwanele Tshabalala - kwanele@parkupp.co.za
            <br>
            Umar Obaray - umar@parkupp.co.za`,
        })
    }

    onSubmit() {
        this.formLoading = true
        // this.formError = ''

        this.enquiry.patch(this.formGroup.value)
        this.enquiry.createdAt = serverTimestamp() as firestore.Timestamp
        console.log(this.enquiry)

        addDoc(collection(this.clientService.firestore, enquiriesPath()), this.enquiry.parse()).then((docRef) => {
            this.formLoading = false
            this.router.navigate([`/corporate/complete`])
            return
        })
    }

    listParking() {
        this.router.navigate(['/sign-up'])
    }

    calculateRevenue() {
        const values = this.calculatorForm.value
        const numBays = Number(values.numBays) || 0
        const costPerBay = Number(values.costPerBay) || 0
        const numMonths = Number(values.numMonths) || 0

        if (numBays > 0 && costPerBay > 0 && numMonths > 0) {
            // Calculate total revenue
            const totalRevenue = numBays * costPerBay * numMonths

            // Deduct ParkUpp's 15% service fee
            const landlordRevenue = totalRevenue * 0.85

            this.calculatedRevenue = `R${Math.round(landlordRevenue).toLocaleString('en-ZA')}`
        } else {
            this.calculatedRevenue = 'R0'
        }
    }
}
